module.exports = __webpack_public_path__ + "static/img/pieswr.5dc8a76c.webp";